import { DateTime } from "luxon";
const now = DateTime.local();

// Today start and end
const today = [
    new DateTime.now().startOf("day"),
    new DateTime.now().endOf("day"),
  ];

// Yesterday start and end
const yesterdayStart = today[0].minus({ days: 1 });
const yesterdayEnd = today[0].minus({ seconds: 1 });

// This week start (Sunday) and end (today end)
const thisWeekStart = today[0].startOf("week");
const thisWeekEnd = today[1];

// Last week start and end
const lastWeekStart = thisWeekStart.minus({ weeks: 1 });
const lastWeekEnd = thisWeekStart.minus({ seconds: 1 });

// This month start and end
const thisMonthStart = today[0].startOf("month");
const thisMonthEnd = today[1];

// Last month start and end
const lastMonthStart = thisMonthStart.minus({ months: 1 });
const lastMonthEnd = thisMonthStart.minus({ seconds: 1 });

// Last 30 days
const lastThirtyDaysStart = today[0].minus({ days: 30 });
const lastThirtyDaysEnd = today[1];
const presets = [
  {
    label: "Today",
    getValue: () => [today[0], today[1]],
  },
  {
    label: "Yesterday",
    getValue: () => [yesterdayStart, yesterdayEnd],
  },
  {
    label: "This Week",
    getValue: () => [thisWeekStart, thisWeekEnd],
  },
  {
    label: "Last Week",
    getValue: () => [lastWeekStart, lastWeekEnd],
  },
  {
    label: "This Month",
    getValue: () => [thisMonthStart, thisWeekEnd],
  },
  {
    label: "Last Month",
    getValue: () => [lastMonthStart, lastMonthEnd],
  },
  {
    label: "Last 30 Days",
    getValue: () => [lastThirtyDaysStart, lastThirtyDaysEnd],
  },
];
export { presets, today };